import Grid from '@mui/material/Grid'

import AuthLogin from './AuthLogin'
import Logo from '@components/Logo'

const Login = () => {
    return (
        <Grid
            container
            direction="column"
            alignItems="center"
            sx={{ paddingTop: '15vh' }}
        >
            <Grid item xs={12} sx={{ mb: 3, mt: 5 }}>
                <Logo />
            </Grid>
            <Grid item xs={12}>
                <AuthLogin />
            </Grid>
        </Grid>
    )
}

export default Login
